/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
require('./vendor/element-parallax');
require('./vendor/slick-slider');
// require('./vendor/TweenMax.min.js');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');

// App Requires
//require('./app/dropcap');
//require('./app/expanding-search');
//require('./app/image-fullscreen');
require('./app/match-width');
require('./app/parallax');
require('./app/primary-nav');
require('./app/sliding-nav-indicators');
require('./app/section-pull-up');
require('./app/modals');
require('./app/collapse');
require('./app/slider-match-height');
require('./app/back-to-top');
require('./app/video-popup');
require('./app/get-pledge-count');
require('./app/videos');
require('./app/footer');
require('./app/blog');

/*Slider Requires*/
require('./app/sliders/slider-col-1');
require('./app/sliders/slider-col-3');
require('./app/sliders/slider-col-6');
require('./app/sliders/slider-partners');

// Animation Requires
// require('./app/animations/global-animation');

require('./app/blocks/locations-search');
require('./app/blocks/talent-community');
require('./app/blocks/jobs-map');
require('./app/blocks/contact-page');
require('./app/blocks/inline-pdf');
